import { NgModule } from '@angular/core';
import {
  ActionBarCenterContentDirective,
  ActionBarComponent,
  ActionBarLeftContentDirective,
  ActionBarRightContentDirective,
} from './components/action-bar/action-bar.component';
import { ErrorPipe } from './pipes/error/error.pipe';
import { YesNoPipe } from './pipes/yes-no/yes-no.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { ReleaseNotesComponent } from './components/release-notes/release-notes.component';
import { XpoFooterModule } from '@xpo-ltl/ngx-ltl-core/footer';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';

@NgModule({
  declarations: [
    // Components
    ActionBarComponent,
    ActionBarLeftContentDirective,
    ActionBarCenterContentDirective,
    ActionBarRightContentDirective,
    FooterComponent,
    ReleaseNotesComponent,
    // Pipes/Directives
    ErrorPipe,
    YesNoPipe,
  ],
  imports: [
    // Pipes/Directives
    XpoFooterModule,
    XpoDialogModule,
    XpoButtonModule,
    XpoCardModule,
  ],
  exports: [
    // Components
    ActionBarComponent,
    ActionBarLeftContentDirective,
    ActionBarCenterContentDirective,
    ActionBarRightContentDirective,
    FooterComponent,
    ReleaseNotesComponent,
    // Pipes/Directives
  ],
  // providers:  MAKE providedIn: 'root' on your services!!!
})
export class SharedModule {}
